export const firebaseConfig = {
  apiKey: "AIzaSyAm5DLkbcalzgMtxDrGSFJLQ6YpoD4qw94",
  authDomain: "simpleconstructionsoftware.firebaseapp.com",
  projectId: "simpleconstructionsoftware",
  storageBucket: "simpleconstructionsoftware.appspot.com",
  messagingSenderId: "510213496750",
  appId: "1:510213496750:web:fba637798101f43861323f",
  measurementId: "G-WM7L5G621F",
};
